import {
    REALIZED_FIELD,
    VOTED_TOTAL_FIELD,
    REQUESTED_FIELD,
    VOTED_FIELD,
    BUDGET_YEAR_FIELD,
} from 'routes/BudgetModule/config/constants';
import { BasePivotFieldT, ChartSettingsT } from 'business/definitions';

const REALIZED_FIELD_CAMEL = REALIZED_FIELD.replace('.', '');
const VOTED_TOTAL_FIELD_CAMEL = VOTED_TOTAL_FIELD.replace('.', '');
const REQUESTED_FIELD_CAMEL = REQUESTED_FIELD.replace('.', '');
const VOTED_FIELD_CAMEL = VOTED_FIELD.replace('.', '');
const BUDGET_YEAR_FIELD_CAMEL = BUDGET_YEAR_FIELD.replace('.', '');

// pivotFields is the settings that gives the headers order in the pivot table
const defaultPivotFields: BasePivotFieldT[] = [
    {
        dataField: REALIZED_FIELD_CAMEL,
        area: 'data',
        areaIndex: 5,
        summaryType: 'sum',
    },
    {
        dataField: VOTED_TOTAL_FIELD_CAMEL,
        area: 'data',
        areaIndex: 1,
        summaryType: 'sum',
    },
    // The trick proposed by DevExtreme to show some data fields on some years only,
    // consists in leaving the "dataField" of these fields blank, and set their "summaryType" to "custom".
    { dataField: '', area: 'data', areaIndex: 2, summaryType: 'custom' },
    { dataField: '', area: 'data', areaIndex: 3, summaryType: 'custom' },
    { dataField: '', area: 'data', areaIndex: 4, summaryType: 'custom' },
    // @ts-expect-error [TS migration] (previously $FlowFixMe) Area not defined here, this code might be obsolete due to migration to aggrid
    { dataField: REQUESTED_FIELD_CAMEL },
    // @ts-expect-error [TS migration] (previously $FlowFixMe) Area not defined here, this code might be obsolete due to migration to aggrid
    { dataField: VOTED_FIELD_CAMEL },
    {
        dataField: BUDGET_YEAR_FIELD_CAMEL,
        area: 'row', // necessary to display the metric compared by budget year
        areaIndex: 0,
        summaryType: '',
    },
];
const defaultPivotTableSettings: ChartSettingsT = {
    rowHeight: 'sm',
    pageSize: 10,
    pivotFields: defaultPivotFields,
    displayBy: 'default',
};

const pieDefaultChartSettings: ChartSettingsT = {
    palette: 'manty',
    displayBy: 'default',
};
const barDefaultChartSettings: ChartSettingsT = {
    palette: 'kandinsky',
    isYearlyComparison: false,
    areLabelsShown: true,
    areLabelsShownInside: false,
    areLabelsVertical: false,
    isEvolutionDisplayed: false,
    areTicksRotated: false,
    showLegend: true,
    isStackedBars: false,
    useSmartMultiMetrics: true,
    showAggregates: true,
    wrapVerticalAxisLabels: false,
    verticalAxisWidth: 'sm',
    displayBy: 'default',
};

/**
Create default chart settings depending on the vizType
By default the viz type is the bar chart.
*/
export const getChartSettings = (vizType: string): ChartSettingsT => {
    switch (vizType) {
        case 'pie':
        case 'donut':
            return pieDefaultChartSettings;
        case 'bar':
        case 'horizontal_bar':
        case 'polar_bar':
        case 'pyramid':
        case 'pivot_table':
            return barDefaultChartSettings;
        case 'table':
            return defaultPivotTableSettings;
        default:
            return barDefaultChartSettings;
    }
};
